var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_2357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9837 4.82345C11.9756 4.73883 11.9383 4.65966 11.8782 4.59955C11.8181 4.53945 11.739 4.50214 11.6543 4.49406C11.5566 4.48473 9.24385 4.28068 7.89711 5.62745C7.60507 5.91948 7.38607 6.25693 7.22206 6.60735C6.95199 5.50147 6.47161 4.58396 5.81211 3.92448C4.99927 3.11164 3.79453 2.57085 2.32819 2.36059C1.23713 2.20412 0.387543 2.28228 0.351918 2.28573C0.267297 2.29382 0.188133 2.33112 0.128025 2.39123C0.0679164 2.45133 0.0306146 2.5305 0.0225269 2.61512C0.019105 2.65074 -0.0590591 3.50031 0.0973862 4.59139C0.307644 6.05774 0.848417 7.26249 1.66128 8.07531C2.47411 8.88814 3.67885 9.42894 5.14519 9.6392C5.68521 9.71663 6.16596 9.73658 6.51823 9.73658C6.83745 9.73656 7.30266 9.73032 7.51683 9.73032C8.26585 9.73032 9.83349 9.59757 10.8503 8.58067C12.1971 7.23397 11.9931 4.92127 11.9837 4.82345ZM3.99537 5.74121C3.85252 5.59836 3.62086 5.59836 3.47796 5.74121C3.33509 5.88406 3.33509 6.11572 3.47796 6.25862L6.21832 8.99895C5.16242 8.9634 3.3409 8.72019 2.17866 7.55795C0.79355 6.17284 0.715035 3.83928 0.735636 2.99842C1.57653 2.97648 3.90619 3.05338 5.29472 4.44191C6.45361 5.6008 6.69781 7.42342 6.7346 8.48045L3.99537 5.74121ZM10.333 8.06331C9.68806 8.70821 8.71777 8.91463 8.02053 8.97467L9.63242 7.36276C9.77529 7.21991 9.77529 6.98825 9.63242 6.84535C9.48957 6.7025 9.25791 6.7025 9.11501 6.84535L7.50169 8.45867C7.56082 7.76232 7.76665 6.79264 8.41446 6.14483C9.25379 5.30549 10.6441 5.20864 11.2667 5.21101C11.269 5.83365 11.1721 7.2241 10.333 8.06331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_2357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.d8e16d817c5a8d241fc6ef5572a69173.svg";
export { ForwardRef as ReactComponent };